import type { InternalUserProfile } from '../../../services/userProfile';
import type { ExtraditionMlaWizardDraft } from '../../../types/extraditionMlaCaseRequest';

export type ExtraditionMlaSubmissionFields = Pick<
  ExtraditionMlaWizardDraft,
  | 'submittedByUserId'
  | 'submittedByDisplayName'
  | 'submittedDivisionName'
  | 'submitterDesignation'
  | 'submitterEmail'
  | 'submitterContactNo'
>;

export function submissionFieldsFromInternalProfile(
  profile: InternalUserProfile,
): ExtraditionMlaSubmissionFields {
  const displayName =
    profile.userDisplayName.trim() ||
    [profile.firstName, profile.lastName].filter(Boolean).join(' ').trim() ||
    profile.username;

  return {
    submittedByUserId: profile.appUserId,
    submittedByDisplayName: displayName,
    submittedDivisionName: profile.divisionName,
    submitterDesignation: profile.designation,
    submitterEmail: profile.username,
    submitterContactNo: profile.contactNumber,
  };
}

export function applySubmissionFieldsToDraft(
  draft: ExtraditionMlaWizardDraft,
  fields: ExtraditionMlaSubmissionFields,
): ExtraditionMlaWizardDraft {
  return { ...draft, ...fields };
}
